<template>
    <div class="w-full flex mt-5 lg:mt-0">
        <payment class="z-50" user_id="" :coupons="usableCoupons" :company="company" @showLoginOrRegisterModal="showLoginOrRegisterModal"></payment>

        <div class="flex flex-col sm:flex-row w-full xl:w-3/4 lg:mx-20 xl:mx-auto">
            <div class="self-center hidden lg:flex flex-col border-r-2 border-white pr-10 h-64 text-white font-weight-bold space-y-6 justify-center">
                <div @click="changeStep(1)" :class="[ (currentStep == 1 ? '' : 'opacity-50'), (maxStep > 1 ? 'cursor-pointer' : '')]">Steg 1: Lokal</div>
                <div @click="changeStep(2)" :class="[ (currentStep == 2 ? '' : 'opacity-50'), (maxStep > 2 ? 'cursor-pointer' : '')]">Steg 2: Behandling</div>
                <div @click="changeStep(3)" :class="[ (currentStep == 3 || this.currentStep == 4 ? '' : 'opacity-50'), (maxStep >= 3 ? 'cursor-pointer' : '')]">Steg 3: Datum</div>
            </div>

            <div class="flex sm:items-center sm:justify-center w-full lg:w-4/5 h-full">
                <transition name="fade-custom" mode="out-in">
                    <div v-if="currentStep == 1" class="flex flex-row w-full md:w-1/2 px-10 md:px-0" key="location">
                        <div class="flex flex-col w-full text-white">
                            <coupon-info :coupons="usableCoupons" :show-warning="company.id == 48"></coupon-info>

                            <img v-if="company.hasLogo" :src="company.logo" class="mb-4 block w-auto h-auto mx-auto" style="max-height: 205px; max-width: 205px;">
                            <img v-else :src="company.bigLogo" class="mb-4 block w-auto h-auto mx-auto" style="max-height: 205px; max-width: 205px;">

                            <div class="text-2xl md:text-4xl text-center">Välkommen {{company.name}}</div>

                            <div v-if="error" class="bg-red-600 bg-opacity-75 p-4 rounded-lg m-4 text-center">
                                {{ error }}
                            </div>

                            <div v-else>
                                <div class="mt-4 text-center">Välj din ort/kontor och gå vidare.</div>
                                <div class="flex flex-col mt-6">
                                    <multiselect
                                            class="border-brand large-multiselect focus:ring-transparent"
                                            :clearOnSelect='false'
                                            v-model="selectedCities"
                                            :options="cities"
                                            :showLabels="false"
                                            :hideSelected="true"
                                            placeholder="Sök din ort/kontor"
                                            selectLabel=""
                                            deselectLabel=""
                                            :multiple="true"
                                            :close-on-select="false"></multiselect>
                                    <template slot="caret">
                                        <div>
                                            <div @mousedown.prevent.stop="toggle()" class="multiselect__select">
                                                <i class="icon-down"></i>
                                            </div>
                                        </div>
                                    </template>
                                    <div class="mt-2">
                                        <p class="py-2 text-base cursor-pointer text-center md:text-left text-xl md:text-base" @click="selectAllCities()" v-if="selectedCities.length != filterLocations.length">Välj alla mina orter</p>
                                        <p class="py-2 text-base cursor-pointer text-center md:text-left text-xl md:text-base" @click="deselectAllCities()" v-else>Välj ingen ort</p>
                                    </div>
                                </div>

                                <div  class="w-full flex justify-end text-xl self-end">
                                    <button class="px-8 py-2 text-white md:bg-tlmblue2 rounded-lg flex items-center text-white"
                                            :class="[ selectedLocations.length ? 'opacity-100' : 'opacity-50']"
                                            @click="nextStep">
                                        <span class="mr-1">Gå vidare</span>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="19.266" height="19.266" viewBox="0 0 19.266 19.266" fill="currentColor"><path class="b" d="M5.88,3.7l6.326,6.326L5.88,16.353l1.7,1.7,8.027-8.027L7.582,2Z" transform="translate(-1.16 -0.395)"/></svg>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div v-else-if="currentStep == 2" class="self-center w-full sm:w-1/2 px-4" key="treatment">
                        <div class="flex flex-col items-center text-white">
                            <coupon-info :coupons="usableCoupons" :show-warning="company.id == 48"></coupon-info>

                            <img v-if="company.hasLogo" :src="company.logo" class="mb-4 block w-auto h-auto mx-auto" style="max-height: 205px; max-width: 205px;">
                            <img v-else :src="company.bigLogo" class="mb-4 block w-auto h-auto mx-auto" style="max-height: 205px; max-width: 205px;">

                            <div class="text-4xl text-center font-weight-bold">Välkommen {{company.name}}</div>
                            <div class="mt-3 text-center">Välj din behandling och gå vidare.</div>
                            <div class="flex flex-col flex-wrap lg:flex-row mt-6">
                                <div v-for="treatment in treatmentsAndPrices" class="w-full mr-10 pb-4 inline-flex flex-col flex-wrap justify-start lg:justify-center">
                                    <input :id="'treatmenttype_' + treatment.id" v-model="selectedTreatment" type="radio" name="radio" class="hidden" :value="treatment.id"/>
                                    <label :for="'treatmenttype_' + treatment.id" class="flex items-center cursor-pointer text-xl">
                                        <span class="w-6 h-6 inline-block mr-2 rounded-full border-white flex items-center justify-center" style="border-width: 3px;">
                                            <span class="w-3 h-3 inline-block rounded-full bg-white justify-center" v-if="selectedTreatment == treatment.id"></span>
                                        </span>
                                        {{ treatment.name }} </label>
                                        <p class="ml-8 whitespace-no-wrap pointer-events-none"> {{ treatment.treatment_price > 0 ? `${treatment.treatment_price} kr`: '' }}</p>
                                </div>
                            </div>
                        </div>
                        <div class="w-full flex justify-end md:justify-center text-xl mt-4">
                            <button class="px-8 py-2 text-white md:bg-tlmblue2 rounded-lg flex items-center text-white"
                                    :class="[ this.hasSelectedTreatment ? 'opacity-100' : 'opacity-50']"
                                    @click="hasSelectedTreatment ? nextStep() : false">
                                <span class="mr-1">Gå vidare</span>
                                <svg xmlns="http://www.w3.org/2000/svg" width="19.266" height="19.266" viewBox="0 0 19.266 19.266" fill="currentColor"><path class="b" d="M5.88,3.7l6.326,6.326L5.88,16.353l1.7,1.7,8.027-8.027L7.582,2Z" transform="translate(-1.16 -0.395)"/></svg>
                            </button>
                        </div>
                    </div>

                    <div v-if="currentStep == 3 || currentStep == 4" class="flex flex-col w-full md:px-5 md:px-20 lg:px-0 lg:pl-10" key="calendar">
                        <coupon-info :coupons="usableCoupons" :show-warning="company.id == 48"></coupon-info>

                        <div class="hidden lg:block w-full lg:w-2/3 text-white">
                            <div class="text-3xl text-center hidden sm:block max-w-full">Välj datum</div>
                            <div class="text-center hidden md:block max-w-full">Du kan välja ett eller flera tillfällen.</div>
                        </div>
                        <div class="flex flex-col-reverse lg:flex-row">
                            <div class="w-full lg:w-2/3 text-white">
                                <div class="lg:hidden w-full lg:w-2/3 text-white mt-5">
                                    <div class="text-3xl text-center hidden sm:block max-w-full">Välj datum</div>
                                    <div class="text-center hidden md:block max-w-full">Du kan välja ett eller flera tillfällen.</div>
                                </div>
                                <calendar :ajax-url="ajaxUrl"
                                          date-key="start"
                                          @daySelected="setDate"
                                          ref="calendar"
                                          :disablePastDays="true"
                                          :initial-date="initialDate"
                                          :open-initial="redirected"
                                ></calendar>
                            </div>
                            <div class="w-full lg:w-1/3 lg:ml-10">
                                <reservations-new
                                    :company="company"
                                    :reservations="reservations"
                                    :user_id="user_id == null ? null : user_id"
                                    @removeReservationWithId="removeReservation"
                                    @reservationsExpired="$refs.calendar.ajaxEvents()"
                                    @showpayinfo
                                    ref="reservations"
                                    :consultant="consultant"
                                ></reservations-new>
                            </div>
                        </div>
                    </div>
                </transition>
            </div>
        </div>

        <double-booking v-if="showDoubleBooking" :schedule="doublebookingSchedule"
                        @makeReservation="makeReservation"
                        @makeReservationById="makeReservationById"
                        @noDoubleBooking="hideDoubleBookingModal"
        ></double-booking>

        <div ref="bookingmodal" class="booking-modal background-image fixed top-0 left-0 w-full h-screen hidden" style="z-index: 100">
            <div class="modal-container w-full h-screen absolute top-0 right-0 flex items-center justify-center" style="z-index: 120" @click="toggleModal">
                <div class="modal-close absolute top-0 right-0 mr-5 md:mt-32 md:mr-10 cursor-pointer flex flex-col items-center mt-4 mr-4 text-white">
                    <img src="/images/large-cross.png" style="width: 32px; height: 32px">
                </div>

                <div class="modal-content w-full px-10 lg:p-0 lg:w-2/3 self-center">
                    <div v-if="date" class="w-full pt-48 md:pt-0 ">
                        <div class="text-3xl text-white">{{ formattedSelectedDate }}</div>
                        <div class="flex flex-row md:mt-4">
                            <div class="booking-modal-center-container flex flex-1 flex-col md:flex-row border-white text-left text-white overflow-y-auto pb-40 md:pb-0">
                                <div v-for="(scheduleGroup, index) in groupedSchedules" :class="groupedSchedules.length == 1 ? 'w-full' : `w-1/${groupedSchedules.length}`">
    
                                    <div class="flex flex-row">
                                    <div>
                                        <div>Lokal: {{scheduleGroup[0].location.name}}</div>
                                        <div class="mb-4">Massör: {{scheduleGroup[0].therapist.user ? scheduleGroup[0].therapist.user.name : ''}}</div>
                                    </div>
                                    <img 
                                        :src="'/therapist_profile_picture/' + scheduleGroup[0].therapist.profile_picture_path" 
                                        class="w-12 h-12 rounded-full ml-4 object-cover" 
                                        v-if="scheduleGroup[0].therapist.profile_picture_path">                                    
                                    </div>
                                    <div class="md:border-r md:pr-4" :class="index > 0 ? 'md:px-4' : 'md:pr-4'">
                                        <div v-for="schedule in scheduleGroup" class="flex flex-row justify-between items-center my-2 py-3 pl-5 pr-3 bg-dark-transparent rounded">
                                            <div class="font-bold">{{formattedScheduleTimes(schedule)}}</div>
                                            <div class="">
                                                <button class="rounded bg-tlmblue2 px-8 py-1"
                                                        @click="makeReservation(schedule, false)"
                                                        v-if="!cannot_book && !schedule.booking">
                                                    {{transEdit('book')}}
                                                </button>
                                                <button class="rounded bg-green-500 px-8 py-1"
                                                        v-else-if="!cannot_book && bookedByMe(schedule) && !schedule.booking.confirmed"  disabled>
                                                    Bokad
                                                </button>
                                                <button class="rounded bg-green-500 px-8 py-1"
                                                        v-else-if="!cannot_book && bookedByMe(schedule) && schedule.booking.confirmed"  disabled>
                                                    Bokad
                                                </button>
                                                <button class="rounded bg-orange-500 text-white px-8 cursor-default"
                                                        v-else-if="!cannot_book && canQueue(schedule)" @click="queueForSchedule(schedule)">
                                                    <span><i class="fa fa-ban"></i> Köa </span>
                                                </button>
                                                <button class="rounded bg-red-300 text-white px-8 cursor-default"
                                                        v-else-if="!cannot_book && isQueued(schedule)" @click="removeFromQueue(schedule)">
                                                    <i class="fa fa-ban"></i> Sluta köa
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="hidden md:flex flex-col w-/4 lg:w-1/3 pl-10 text-white">
                                <div class="flex flex-col">
                                    <div class="pb-4">
                                        <span class="text-2xl">Valda tider</span>
                                    </div>
                                    <div v-if="!reservations.length">
                                        <span class="text-gray-200 pt-4">Välj tid för att gå vidare</span>
                                    </div>
                                    <div v-else class="flex flex-row">
                                        <modal-reservations
                                                :company="company"
                                                :reservations="reservations"
                                                :user_id="user_id == null ? null : user_id"
                                                @removeReservationWithId="removeReservation"
                                                @reservationsExpired="$refs.calendar.ajaxEvents()"
                                                @reservationsDone="reservationsDone"
                                                ref="reservations"
                                                :consultant="consultant"
                                        ></modal-reservations>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import BookingModal from './BookingModal.vue'
    import QueueModal from './QueueModal.vue'
    import AbortQueueModal from './AbortQueueModal.vue'
    import ModalLoginOrRegister from "./ModalLoginOrRegister.vue";
    import CouponInfo from "./CouponInfo";
    import Vue from 'vue';

    export default {
        name: "BookingNew",
        components: {CouponInfo},
        props: ['therapists', 'treatments', 'initialReservations', 'user_id', 'cannot_book', 'company', 'locations',
            'consultant', 'initial_location', 'initial_date', 'booking_location_ids', 'initial_treatment', 'initial_queues', 'error', 'coupons'],
        data () {
            let initialDate = null;

            if (this.initial_date && this.initial_date != "null") {
                initialDate = moment(this.initial_date, "Y-M-D");
            } else {
                initialDate = moment();
            }

            return {
                date: null,
                redirected: false,
                initialDate: initialDate,
                selectedTreatment: null,
                selectedLocations: [],
                queuedSchedules: this.initial_queues,
                reservedSchedules: [1, 2, 3],
                currentStep: 1,
                maxStep: 1,
                doublebookingSchedule: [],
                showDoubleBooking: false,
                selectedService: {
                    type: []
                },
                reservations: this.initialReservations,
                servicetypes: [{
                        "id": 1,
                        "name": "Massage"
                    },
                    {
                        "id": 2,
                        "name": "Kiropraktik"
                    },
                    {
                        "id": 3,
                        "name": "Tjänst"
                    }
                ],
                treatmentsAndPrices: [],
                selectedCities: [],
            }
        },
        created() {
            let simplifiedLocations = [];
            if(this.locations) {
                this.locations.forEach((location) => {
                    let tempAddressString = location.name;
                    if (location.city) {
                        tempAddressString = location.city.name + ' - ' + tempAddressString;
                    }
                    simplifiedLocations.push({
                        id: location.id,
                        address:  tempAddressString,
                    });
                });
            }
            let self = this;
            if (this.booking_location_ids && simplifiedLocations) {
                this.selectedLocations = simplifiedLocations.filter(function (el) {
                    return self.booking_location_ids.includes(el.id)
                });
            }

            let first = true;
            let url = '/book/gettreatmentprices';

            let symbol = '?';

            this.treatments.forEach((treatment) => {
                url += symbol+'treatment_ids[]='+treatment.id;
                if(first){
                    symbol = '&';
                    first = false;
                }
            });
            url += symbol+'company_id='+this.company.id;

            axios.get(url).then((res) => {
                this.treatmentsAndPrices = res.data;
                if(this.treatmentsAndPrices.length == 1) {
                    this.selectedTreatment = this.treatmentsAndPrices[0].id;

                    if(this.currentStep == 2) {
                        this.currentStep = 3;
                    }
                }
            }).catch((res) => {
                this.loading = false;
            });

            if(this.cities.length == 1) {
                this.selectedCities = [this.cities[0]];
                this.currentStep = 2;
            }

            if(this.initial_treatment) {
                this.selectedTreatment = this.initial_treatment;
                this.redirected = true;
                this.currentStep = 3;
            }

            if(this.initialReservations.length > 0) {
                this.selectedTreatment = this.initialReservations[0].treatment.id;
                this.currentStep = 3;
                this.selectedTreatment = this.initialReservations[0].treatment_id;
            }
        },
        mounted () {
            this.$eventHub.$on('newQueueList', this.setNewQueueList);
        },
        methods: {
            setNewQueueList(newQueueList) {
                this.queuedSchedules = newQueueList;
            },
            canQueue(schedule) {
                return !! schedule.booking && ! this.queuedSchedules.includes(schedule.id);
            },
            isQueued(schedule) {
                return (!! this.user_id) && this.queuedSchedules.includes(schedule.id);
            },
            showLoginOrRegisterModal() {
                this.$modal.show(ModalLoginOrRegister, {
                    'company': this.company,
                }, {
                    'width': '100%',
                    'height': 'auto',
                    'max-width': 800,
                    'adaptive': true,
                    'clickToClose': true,
                })
            },
            selectAllCities () {
                this.selectedCities = this.cities;
            },
            deselectAllCities () {
                this.selectedCities = [];
            },
            logoutUser () {
                $("#logout-form").submit();
            },
            closeModal (event) {
                const modal = this.$refs["bookingmodal"];
                modal.classList.add('hidden');
            },
            bookedByMe(schedule) {
                let scheduleIDs = this.reservations.map(reservation => reservation.schedule_id);

                return scheduleIDs.includes(schedule.id);
            },
            getParameterByName(name, url) {
                if (!url) url = window.location.href;
                name = name.replace(/[\[\]]/g, '\\$&');
                var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
                    results = regex.exec(url);
                if (!results) return null;
                if (!results[2]) return '';
                return decodeURIComponent(results[2].replace(/\+/g, ' '));
            },
            makeReservationById(scheduleId, doubleBooking) {
                let tempSchedule = this.getScheduleFromGroup(scheduleId);

                if (tempSchedule && tempSchedule.length) {
                    this.makeReservation(tempSchedule[0], doubleBooking)
                }
            },
            makeReservation(schedule, doubleBooking){
                if(this.selectedTreatment){
                    var self = this;
                    axios.post('/reservations/reserve', {
                        'id': schedule.id,
                        'treatment_id': this.selectedTreatment,
                        'company_id': this.company.id
                    }).then((res) => {
                        if(res.data.success) {
                            schedule.booking = true;
                            this.reservations.push(res.data.booking);

                            self.showDoubleBooking = false;
                            if(this.company.can_doublebook) {
                                axios.get('/available_doublebooking/' + schedule.id).then((res) => {
                                    if(res.data.length) {
                                        self.doublebookingSchedule = res.data;
                                        self.showDoubleBooking = true;
                                    }
                                });
                            }
                        } else {
                            Vue.toasted.error(res.data.info_string);
                        }
                    });
                }
            },
            selectSchedule(schedule){
                this.selectedSchedule = schedule;
                this.$modal.show(BookingModal, {
                    'schedule': this.selectedSchedule,
                    'company': this.company,
                    'consultant': this.consultant
                }, {
                    'width': '100%',
                    'height': 'auto',
                    'max-width': 800,
                    'adaptive': true,
                    'clickToClose': false,

                }, {
                    'before-close': this.closeModal
                })
            },
            queueForSchedule(schedule){
                this.$modal.show(QueueModal, {
                    'schedule': schedule,
                    'treatment_id': this.selectedTreatment,
                    'consultant': this.consultant,
                    'user_id': this.user_id,
                }, {
                    'width': '100%',
                    'height': 'auto',
                    'max-width': 800,
                    'adaptive': true,
                    'clickToClose': false,
                }, {
                    'before-close': this.closeModal,
                })
            },
            removeFromQueue(schedule){
                this.$modal.show(AbortQueueModal, {
                    'schedule': schedule,
                }, {
                    'width': '100%',
                    'height': 'auto',
                    'max-width': 800,
                    'adaptive': true,
                    'clickToClose': false,
                }, {
                    'before-close': this.closeModal
                })
            },
            getScheduleFromGroup(scheduleId) {
                let tempSchedule = null;
                this.groupedSchedules.forEach(scheduleGroup => {
                    let foundSchedules = scheduleGroup.filter((schedule) => {
                        return schedule.id == scheduleId;
                    });

                    if (foundSchedules && foundSchedules.length) {
                        tempSchedule = foundSchedules;
                    }
                });
                return tempSchedule
            },
            setBookingToNullForSchedule(scheduleId) {
                if (! scheduleId) {
                    return;
                }

                let tempSchedule = this.getScheduleFromGroup(scheduleId);

                if (tempSchedule && tempSchedule.length) {
                    tempSchedule[0].booking = null;
                }
            },
            removeReservation(id) {
                let filteredReservation = this.reservations.filter(function (reservation) {
                    return id == reservation.id;
                });
                let scheduleId = filteredReservation.length ? filteredReservation[0].schedule_id : null;

                axios.post('/reservations/delete', {id: id}).then((res) => {
                    this.reservations = this.reservations.filter(function (reservation) {
                        return id != reservation.id;
                    });

                    this.setBookingToNullForSchedule(scheduleId);

                    if (this.$refs.calendar) {
                        this.$refs.calendar.ajaxEvents();
                    }
                });

                return false;
            },
            setDate (date) {
                if (! date || ! date.events) {
                    return;
                }
                this.date = date;

                if(this.date.events.length) {
                    this.toggleModal();
                }

            },
            formattedScheduleTimes (schedule) {
                let start = moment(schedule.start);
                let end = moment(schedule.end);
                return start.format("HH:mm") + " - " + end.format("HH:mm");
            },
            nextStep() {
                this.currentStep++;
                this.maxStep++;
            },
            showDoubleBookingModal() {
                this.showDoubleBooking = true;
            },
            hideDoubleBookingModal() {
                this.showDoubleBooking = false;
            },
            toggleModal () {
                const modal = this.$refs["bookingmodal"];
                modal.classList.toggle('hidden');
            },
            reservationsDone() {
                this.$refs.calendar.ajaxEvents();
                this.closeModal();
            },
            updateReservations() {
                this.$refs.calendar.ajaxEvents();
            },
            changeStep(step) {
                if(this.maxStep > step) {
                    if(this.currentStep == 4) {
                        const reservationList = document.querySelector('.reservation-step');
                        reservationList.classList.toggle('opacity-0');
                    }

                    this.currentStep = step;
                }
            }
        },
        computed: {
            usableCoupons() {
                if(this.selectedTreatment) {
                    return this.coupons.filter((_) => _.treatment_id == this.selectedTreatment);
                }

                return this.coupons;
            },

            cities() {
                return _.uniq(this.locations.map((location) => location.city.name));
            },
            formattedSelectedDate() {
                if(!this.date.date) {
                    return '';
                }

                let dateString = moment(this.date.date).format('dddd D MMMM');

                return dateString[0].toUpperCase() + dateString.substr(1);
            },

            groupedSchedules () {
                let groupedSchedules = [];
                let events = this.date ? this.date.events : [];

                let numberOfGroups = 0;

                for (let event of events) {
                    let arrayKey = event.therapist_id + ' ' + event.location_id;

                    if ((! (arrayKey in groupedSchedules))) {
                        numberOfGroups++;
                        groupedSchedules[arrayKey] = [];
                    }

                    if (arrayKey in groupedSchedules) {
                        groupedSchedules[arrayKey].push(event);
                    }
                }

                let regrouped = [];

                for (let group in groupedSchedules) {
                    regrouped.push(groupedSchedules[group]);
                }

                return regrouped;
            },
            ajaxUrl () {
                let first = true;
                let url = '/book/filterevents';

                let symbol = '?';

                this.selectedLocations.forEach((location) => {
                    url += symbol+'location_ids[]='+location.id;
                    if(first){
                        symbol = '&';
                        first = false;
                    }
                });

                url += symbol+'treatment_ids[]='+this.selectedTreatment;
                if(first){
                    symbol = '&';
                    first = false;
                }

                url += symbol+'company_id='+this.company.id;

                return url;
            },
            filterTherapists() {
                let simplifiedTherapists = [];
                if(this.therapists){
                    this.therapists.forEach((therapist) => {
                        simplifiedTherapists.push({
                            id: therapist.id,
                            name: therapist.user.name,
                        });
                    });
                }
                return simplifiedTherapists;
            },
            filterLocations() {
                let simplifiedLocations = [];
                if(this.locations){
                    this.locations.forEach((location) => {
                        let tempAddressString = location.name;
                        if (location.city) {
                            tempAddressString = location.city.name + ' - ' + tempAddressString;
                        }
                        simplifiedLocations.push({
                            id: location.id,
                            name:  tempAddressString,
                        });
                    });
                }

                return simplifiedLocations;
            },
            filterTreatments() {
                let simplifiedTreatments = [];
                if(this.treatments){
                    this.treatments.forEach((treatment) => {
                        simplifiedTreatments.push({
                            id: treatment.id,
                            name: treatment.name,
                        });
                    });
                }
                return simplifiedTreatments;
            },
            hasSelectedTreatment () {
                return this.selectedTreatment && this.selectedTreatment > 0;
            },
            hasSelectedLocations () {
                return this.selectedLocations && this.selectedLocations.length > 0;
            },
        },
        watch: {
            selectedTreatment (val) {
                if (val.length <= 0) {
                    //this.selectedLocations = [];
                }
            },
            selectedCities(val) {
              if (val.length <= 0) {
                this.selectedLocations = [];
              } else {
                this.selectedLocations = this.locations.filter((location) => this.selectedCities.includes(location.city.name))
              }
            },
            date (val) {
            }
        },
    }
</script>

<style scoped>
    .mw-1_2 {
        max-width: 33%;
    }

    .btn-primary-dark {
        color: white;
        background-color: rgb(33, 114, 188);
    }

    .book-button {
        margin: 5px 10px;
    }

    .booking-profile-picture {
        height: 120px;
        width: 120px;
        border-radius: 100%;
        border: 2px solid rgba(0,0,0,0.1);
    }

    .schedules-container {
        width: 40%;
    }
    .reserved-schedules-header {
        font-size: 21px;
    }
    .booking-flex {
        flex: 1;
        display: flex;
    }
    .fade-custom-enter-active, .fade-custom-leave-active {
        transition: opacity .8s;
    }
    .fade-custom-enter, .fade-custom-leave-to /* .fade-leave-active below version 2.1.8 */ {
        opacity: 0;
    }

    .slide-enter-active {
        transition: all .5s ease;
    }
    .slide-leave-active {
        transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
    }
    .slide-enter, .slide-leave-to
        /* .slide-fade-leave-active below version 2.1.8 */ {
        transform: translateX(-100px);
        opacity: 0;
    }

    .white-link {
        color: white;
    }
</style>
